import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from '@services/user.service';
import { PageService } from '@services/page.service';
import { take } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';
import { IframeService } from '@services/iframe.service';
import { ScaffoldDialogService } from "@app/framework/dialog/scaffold-dialog.service";
import { OverlayService } from "@services/overlay.service";
import { EnvironmentService } from '@services/environment.service';
import { TypeSelectComponent } from '../type-select/type-select.component';
import { MainSidebarService } from '../../services/main-sidebar.service';


@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
  forwardUrl: string = null;
  provideTotbChallenge: boolean = false;
  provideWhichMfaChallenge: boolean = false;
  provideSmsChallenge: boolean = false;
  mfaSelectionMade: boolean = false;
  username: string = null;
  password: string = null;
  usercode: string = "";
  hidePw = false;
  challengeData: any;
  loginErrorMessage: string = null;
  isWorking: boolean = false;
  challengeSubmitted: boolean;
  showBackToMfaOptions = false;
  

  constructor(
    private overlay: OverlayService,
    public dialog: ScaffoldDialogService,
    private iframeService: IframeService,
    private cookieService: CookieService,
    private userService: UserService,
    private router: Router,
    private route: ActivatedRoute,
    private environmentService: EnvironmentService,
    private page: PageService,
    private mainSidebarService:MainSidebarService
  ) { }

  ngOnInit() {
    this.mainSidebarService.updateState(false)
    // Login Page doesn't need menus
    this.page.updateHideMenu(true);
    this.isWorking = true
    this.userService.isLoggedIn().subscribe((loggedIn) => {
      if (loggedIn) {
        //already logged in, send home
        this.page.updateHideMenu(false);
        this.router.navigate(["/home"]);
      }
      this.isWorking = false
    });

    this.route.queryParamMap.pipe(take(1)).subscribe((paramMap) => {
      this.forwardUrl = paramMap.get("forwardUrl");
      
    });
  }

  get isInIframe() {
    return this.iframeService.isInIframe;
  }

  backToMFASelection() {
    this.logIn();
    this.usercode = "";
    this.provideSmsChallenge = false;
    this.provideTotbChallenge = false;
    this.mfaSelectionMade = false;
    this.provideWhichMfaChallenge = true;
  }

  selectMfaOption(selection) {
    this.mfaSelectionMade = true;

    this.userService
      .submitChallengeSelection(
        this.username,
        selection,
        this.challengeData.Session
      )
      .subscribe((response) => {
        if (response.ChallengeName) {
          this.provideWhichMfaChallenge = false;
          this.challengeData = response;
          this.loginChallenge();
        }
      });
  }

  submitChallenge(challengeType, $event) {
    $event?.preventDefault();
    if (!this.usercode) return;
    this.overlay.open({ overlayStyles: { opacity: ".55" } },'loginchallenge');
    this.challengeSubmitted = true;
    this.userService
      .handleChallenge(
        this.username,
        this.usercode,
        this.challengeData.Session,
        challengeType
      )
      .subscribe((response) => {

        if(response.status!=='ok'){
          this.challengeSubmitted = false
          this.loginErrorMessage ="Unable to login with the input provided"
          this.overlay.close('loginchallenge')
          return
        }
          
          this.userService.getRoleDetails(true).pipe(take(1)).subscribe(
            (role) => {
              console.log(role);
              if (role == null) {
                this.overlay.close('loginchallenge');
                this.loginErrorMessage =
                  "The user doesn't have permission to access this Scaffold instance.";
                this.isWorking = false;
              } else {
                this.overlay.close('loginchallenge');
                console.log("Authenticated");
                this.isWorking = true;
                this.getProductLogin()
              }
            },
            (err) => {
              this.overlay.close('loginchallenge');
              this.challengeSubmitted = false;
              console.log(err);
            }
          );
      });
  }

  loginChallenge() {
    switch (this.challengeData.ChallengeName) {
      case "SELECT_MFA_TYPE": {
        this.showBackToMfaOptions = true;
        this.provideWhichMfaChallenge = true;
        break;
      }
      case "SMS_MFA": {
        this.provideSmsChallenge = true;
        break;
      }

      case "SOFTWARE_TOKEN_MFA": {
        this.provideTotbChallenge = true;
        break;
      }
      case "NEW_PASSWORD_REQUIRED": {
        this.userService.userAttributes.currentAttributes = JSON.parse(
          this.challengeData.ChallengeParameters.userAttributes
        );
        let requiredAttributes = JSON.parse(
          this.challengeData?.ChallengeParameters?.requiredAttributes || {}
        );
        requiredAttributes = requiredAttributes.map((attributes) =>
          attributes.startsWith("userAttributes.")
            ? attributes.substring("userAttributes.".length)
            : attributes
        );
        this.userService.userAttributes.requiredAttributes = requiredAttributes;

        this.userService.sessionDetails = this.userService.userAttributes;
        this.userService.sessionDetails.userName =
          this.challengeData.ChallengeParameters.USER_ID_FOR_SRP;
        this.router.navigate(["/new-password-required"]);
        break;
      }
    }
  }

  getProductLogin(){
    
    this.environmentService.getInstanceDetails().pipe(take(1)).subscribe(details => {
      
      this.overlay.close();
      console.log('DETIALS',details);
      if (details?.instances?.length > 1) {
        const settings: any = {
          context: {
            data: details,
          },
          hasBackdrop: true,
          closeOnBackdropClick: false, // This will prevent the dialog from closing on click
          closeOnEsc: false // This will prevent the dialog from closing on escape
        };
        this.mainSidebarService.updateState(false)

        const dialogRef = this.dialog.open(TypeSelectComponent, settings);
        dialogRef.onClose.subscribe((type) => {
          console.log(type);
          this.environmentService.setSelectedType(type);
          
          this.finishLogin(details);
          this.mainSidebarService.updateState(true)
          this.page.updateHideMenu(false);
          

        });
      } else {
        this.finishLogin(details);
        this.mainSidebarService.updateState(true)
        this.page.updateHideMenu(false);

        
      }
    });
  }


  finishLogin(instanceData) {
    this.userService.checkForMfaEnabled()
    // if (
    //   // (instanceData.wizard_integration_set === false) ||
    //   instanceData.wizard_theme_set === false ||
    //   instanceData.wizard_users_set === false 
    //   // ||
    //   // instanceData.wizard_terms_set === false
    // ) {
    //   this.wizardService.openWizard();
    // }
    var navigateTo = this.forwardUrl ? this.forwardUrl : "/home";
    this.router.navigate([navigateTo]);  
  }


  logIn() {
    this.loginErrorMessage = "";
    this.overlay.open({ overlayStyles: { opacity: ".55" } },'login');
    this.isWorking = true;
    this.userService.login(this.username, this.password).subscribe(
      (data) => {
        
        this.overlay.close('login');
        if (data.ChallengeName) {
          console.log("ChallengeName", data.ChallengeName);
          this.challengeData = data;
          this.overlay.close();
          return this.loginChallenge();
        }
        console.log("Status", data.status);
        const state = data.status;
        if (state === "NotAuthorizedException" || data.error) {
          this.overlay.close();
          this.loginErrorMessage =
            "The username and password combination is incorrect";
          this.isWorking = false;
        } else if (state == "newPasswordRequired") {
          this.overlay.close();
          console.log("Get New Password");
          this.router.navigate(["/new-password-required"]);
        } else if (state === "logged in" || data.access) {
          // Successful login
          // If there is a forward url, go there, otherwise go to the default landing page
          // TODO - figure out home or landing page for user?
          // Check user role, no role = no user in db
          console.log("logged in");
          this.userService
            .getRoleDetails(true)
            .pipe(take(1))
            .subscribe(
              (role) => {
                console.log(role);
                if (role == null) {
                  this.overlay.close();
                  this.loginErrorMessage =
                    "The user doesn't have permission to access this Scaffold instance.";
                  this.isWorking = false;
                } else {
                  this.isWorking = true
                  console.log("Authenticated");
                  this.getProductLogin();
                }
              },
              (err) => {
                console.log(err);
              }
            );
        } else {
          this.overlay.close();
          this.loginErrorMessage = state;
          this.isWorking = false;
        }
      },
      (err) => {
        this.overlay.close();
        this.loginErrorMessage = err.message;
        this.isWorking = false;
      }
    );
  }
}
